module.exports = __webpack_public_path__ + "static/media/alerta-cancelar-tema-IA.265f5f84.svg";